'use strict'

const pick_ = require('lodash/pick')
const maybe = require('folktale/maybe')

const getReferencedCollectionsNames = require('../helpers/getReferencedCollectionsNames')
const promiseRetry = require('../helpers/promiseRetry')

const NUMBER_OF_SCHEMA_RETRIES = 5

const SCHEMA_FETCH_FAILURE_BREADCRUMB = (retry, error) => ({
  category: 'schema',
  message: `LOAD_SCHEMA_FAILURE retry ${retry}/${NUMBER_OF_SCHEMA_RETRIES}`,
  data: { error }
})

const SCHEMA_FETCH_SUCCESS_BREADCRUMB = retry => ({
  category: 'schema',
  message: `LOAD_SCHEMA_SUCCESS after ${retry} retries`
})

module.exports = (wixDataSchemasProxy, Raven) => {
  let isLoadingSchemas = false
  let schemasPromise
  let cachedSchemas = maybe.Nothing()

  const fetchSchemas = () => {
    isLoadingSchemas = true
    let schemaLoadRetryNum = 1
    return promiseRetry(
      () =>
        wixDataSchemasProxy.list().catch(error => {
          Raven.captureBreadcrumb(
            SCHEMA_FETCH_FAILURE_BREADCRUMB(schemaLoadRetryNum, error)
          )
          schemaLoadRetryNum++
          throw error
        }),
      NUMBER_OF_SCHEMA_RETRIES
    )
      .then(schemas => {
        if (schemaLoadRetryNum > 1) {
          Raven.captureException(
            new Error('Fetching schemas required retries'),
            { level: 'info' }
          )
        }
        Raven.captureBreadcrumb(
          SCHEMA_FETCH_SUCCESS_BREADCRUMB(schemaLoadRetryNum)
        )
        cachedSchemas = maybe.Just(schemas)
        isLoadingSchemas = false
        return schemas
      })
      .catch(error => {
        isLoadingSchemas = false
        throw error
      })
  }

  const loadSchemas = () => {
    const isSchemaLoaded = cachedSchemas.matchWith({
      Just: () => true,
      Nothing: () => false
    })
    if (!isLoadingSchemas && !isSchemaLoaded) {
      schemasPromise = fetchSchemas()
    }
    return schemasPromise
  }

  return {
    loadSchemas,
    getSchema: collectionName => getSchema(cachedSchemas, collectionName),
    getReferencedCollectionsSchemas: collectionName =>
      getReferencedCollectionsSchemas(cachedSchemas, collectionName)
  }
}

const getSchema = (schemas, collectionName) =>
  schemas.map(schemas => schemas[collectionName]).getOrElse(maybe.Nothing())

const getReferencedCollectionsSchemas = (schemas, collectionName) =>
  schemas
    .chain(schemas => maybe.fromNullable(schemas[collectionName]))
    .map(mainSchema => getReferencedCollectionsNames(mainSchema))
    .chain(referencedCollectionsNames =>
      schemas.map(schemas => pick_(schemas, referencedCollectionsNames))
    )
    .getOrElse(maybe.Nothing())



// WEBPACK FOOTER //
// ./viewer-app-module/schemaAPI.js